export const SET_MENU_ITEMS_ID = "SET_MENU_ITEMS_ID";
export const SET_SELECTED_PAGE = "SET_SELECTED_PAGE";
export const SHOW_SEARCH = "SHOW_SEARCH"
export const HIDE_SEARCH = "HIDE_SEARCH"
export const SHOW_SIDEBAR = "SHOW_SIDEBAR"
export const HIDE_SIDEBAR = "HIDE_SIDEBAR"
export const SET_CURRENCY = "SET_CURRENCY"